// import React from 'react';
// import { withStyles } from '@material-ui/core/styles';
// import Tooltip from '@material-ui/core/Tooltip';
// import _ from 'lodash'

// const StyledTooltip = withStyles((theme) => ({
//     tooltip: {
//       backgroundColor: 'var(--secondary-color)',
//       color: 'var(--text-color)',
//       // boxShadow: theme.shadows[1],
//       boxShadow: '0px 2px 1px -1px var(--primary-accent2-color),' +
//         '0px 1px 1px 0px var(--primary-accent2-color),' +
//         '0px 1px 3px 0px var(--primary-accent2-color)',
//       fontSize: '0.8rem',
//       fontFamily: 'var(--font-family)',
//       display:'flex',
//       alignItems:'center',
//     },
//     arrow: {color:'var(--secondary-color)'},
//     tooltipPlacementTop: {margin:'0 0 0.5rem 0'},
//     tooltipPlacementBottom:{margin:'0.5rem 0 0 0'},
//     tooltipPlacementRight: {margin:'0 0.5rem 0 0'},
//     tooltipPlacementLeft: {margin:'0 0.5rem 0 0.5rem'}
//   }))(Tooltip);

// // const CustomTooltip = props => {
// //   return (<StyledTooltip {...props}/>)
// // }

// const CustomTooltip = props => {
//   return <StyledTooltip {..._.omit(props, 'children')}>{props.children}</StyledTooltip>
// }

// export default CustomTooltip;

import * as React from 'react';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }}><span>{props.children}</span></Tooltip>
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: 'var(--secondary-color)',
    color: 'var(--text-color)',
    boxShadow: '0px 2px 1px -1px var(--primary-accent2-color),' +
      '0px 1px 1px 0px var(--primary-accent2-color),' +
      '0px 1px 3px 0px var(--primary-accent2-color)',
    fontSize: '0.8rem',
    fontFamily: 'var(--font-family)',
    display:'flex',
    alignItems:'center',
  },
  [`& .${tooltipClasses.arrow}`]: {color:'var(--secondary-color)'},
  [`& .${tooltipClasses.tooltipPlacementTop}`]: {margin:'0 0 0.5rem 0'},
  [`& .${tooltipClasses.tooltipPlacementBottom}`]:{margin:'0.5rem 0 0 0'},
  [`& .${tooltipClasses.tooltipPlacementRight}`]: {margin:'0 0.5rem 0 0'},
  [`& .${tooltipClasses.tooltipPlacementLeft}`]: {margin:'0 0.5rem 0 0.5rem'}
}));

export default CustomTooltip;
